import { render, staticRenderFns } from "./DocumentosVisualizacao.vue?vue&type=template&id=5ca6f7d9&scoped=true"
import script from "./DocumentosVisualizacao.vue?vue&type=script&lang=js"
export * from "./DocumentosVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6f7d9",
  null
  
)

export default component.exports